import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { mapFirebaseError } from "./errorMapper";
async function resizeImage(file, maxSize) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            let { width, height } = img;
            if (width > maxSize || height > maxSize) {
                const ratio = Math.min(maxSize / width, maxSize / height);
                width = Math.round(width * ratio);
                height = Math.round(height * ratio);
            }
            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);
            canvas.toBlob((blob) => {
                if (blob)
                    resolve(blob);
                else
                    reject(new Error("Failed to compress image"));
            }, "image/jpeg", 0.7);
        };
        img.onerror = () => reject(new Error("Failed to load image"));
        img.src = URL.createObjectURL(file);
    });
}
export class FirebaseServiceImageStorage {
    storage = getStorage();
    async uploadServiceImages(files, onProgress) {
        const urls = [];
        try {
            for (let i = 0; i < files.length; i++) {
                const resized = await resizeImage(files[i], 1024);
                const uuid = crypto.randomUUID();
                const storageRef = ref(this.storage, `service_images/${uuid}.jpg`);
                await uploadBytes(storageRef, resized, { contentType: "image/jpeg" });
                const url = await getDownloadURL(storageRef);
                urls.push(url);
                onProgress(i + 1, files.length);
            }
            return urls;
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async deleteImage(url) {
        if (!url.includes("firebasestorage"))
            return;
        try {
            const storageRef = ref(this.storage, url);
            await deleteObject(storageRef);
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
}
//# sourceMappingURL=FirebaseServiceImageStorage.js.map